import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Agendamento } from "../../../../services/Agendamento";
import { IIniciarAgendamentoProps } from "../../../../types/agendamento";

export const useIniciarVistoria = () => {
  return useMutation({
    mutationFn: (data: IIniciarAgendamentoProps) => Agendamento.iniciar(data),
    onError: ({
      response: {
        data: { mensagem },
      },
    }: any) => {
      toast.error(mensagem);
    },
  });
};
